import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from 'react-query';
import theme from './theme/theme';
import MainLayout from './layouts/MainLayout';
import PublicLayout from './layouts/PublicLayout';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { Projects } from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import PublicProjectDetail from './pages/PublicProjectDetail';
import ProjectLines from './pages/projects/ProjectLines';
import ProjectIssueForm from './pages/projects/ProjectIssueForm';
import ProjectIssueDetail from './pages/projects/ProjectIssueDetail';
import ProjectDataAnalysis from './pages/projects/ProjectDataAnalysis';
import { Users } from './pages/Users';
import ChangePassword from './pages/ChangePassword';

// Initialize React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

function App() {
  useEffect(() => {
    console.log('Checking if user data is loaded on startup...');
    // Add logic to check if user data is loaded here
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Public project view routes */}
            <Route
              path="/view/:id"
              element={
                <PublicLayout>
                  <PublicProjectDetail />
                </PublicLayout>
              }
            />
            
            {/* Protected routes */}
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/projects" />} />
                      <Route path="/projects" element={<Projects />} />
                      <Route path="/projects/:id" element={<ProjectDetail />} />
                      <Route path="/projects/:id/lines" element={<ProjectLines />} />
                      <Route path="/projects/:id/data-analysis" element={<ProjectDataAnalysis />} />
                      <Route path="/projects/:id/issues/new" element={<ProjectIssueForm />} />
                      <Route path="/projects/:id/issues/:issueId/edit" element={<ProjectIssueForm />} />
                      <Route path="/projects/:id/issues/:issueId/detail" element={<ProjectIssueDetail />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/change-password" element={<ChangePassword />} />
                    </Routes>
                  </MainLayout>
                </PrivateRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
